export function fmtCm(v: number): string {
  const sign = v > 0 ? '+' : '';
  return `${sign}${v.toFixed(2)} cm`;
}

export function fmtCmYr(v: number): string {
  const sign = v > 0 ? '+' : '';
  return `${sign}${v.toFixed(2)} cm/yr`;
}

export function fmtDate(iso: string): string {
  // Accepts YYYY-MM-DD or full ISO.
  return iso.slice(0, 10);
}

export function fmtNumber(v: number, digits = 2): string {
  return Number(v).toFixed(digits);
}

export function clamp(v: number, min: number, max: number) {
  return Math.min(max, Math.max(min, v));
}

